"use client";

import { useEffect, useState } from "react";

import type { BaseWithRelations } from "@/types/base";

import BaseArticle from "./BaseArticle";

interface Props {
  base: BaseWithRelations;
}

const DESKTOP_BREAKPOINT = 768;

export default function BaseArticleResponsive({ base }: Props) {
  const [isDesktopLayout, setIsDesktopLayout] = useState<boolean | null>(null);

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      `(min-width: ${DESKTOP_BREAKPOINT}px)`
    );

    const update = () => {
      setIsDesktopLayout(mediaQuery.matches);
    };

    update();

    mediaQuery.addEventListener("change", update);
    return () => mediaQuery.removeEventListener("change", update);
  }, []);

  if (isDesktopLayout === null) {
    return <BaseArticle base={base} showInlineAds={false} />;
  }

  // Phase 1 monetization test: disable all legacy in-article AdSense slots.
  // Only the premium GAM base_top_mobile slot should render on base pages.
  return <BaseArticle base={base} showInlineAds={false} />;
}